module.exports = __webpack_public_path__ + "img/extermination-commercial.cfc80dd9.jpg";